module.exports = __webpack_public_path__ + "static/media/logo.ba42041a.png";